import axios from 'axios';
import {API_URL} from '../constants/index.js';
import {useInterceptor} from './apiUtils';

useInterceptor(axios);

export function getGuides(params) {
	return axios({
		method: 'get',
		url: `${API_URL}/guides`,
		params: params
	});
}

export function showGuide(slug, options = {}) {
	return axios({
		method: 'get',
		url: `${API_URL}/guides/${slug}`,
		skipGlobalError: options.skipGlobalError === true,
	});
}
